<template>
  <div class="ibox float-e-margins">
    <div class="ibox-title">
      <h5>สรุปยอดเทรินโอเวอร์ <small>(เฉพาะเกมส์ Casino)</small>
        <small>สามารถค้นหาโดยการ คลิก รายการจากด้านบนได้ (รายการเดินบัญชีล่าสุด)</small>
      </h5>
    </div>
    <div class="ibox-content">
      <div class="form-inline" style="margin-bottom:15px;">
        <div class="form-group">
          <input type="text" class="form-control search-user-request-id" v-model="moreParams.userRequestId"
                 placeholder="เลขที่รายการฝาก"/>
        </div>
        <button class="btn btn-info search-turn-over" style="margin-bottom:0" @click="filterParam">GO</button>
        <button class="btn btn-default" style="margin-bottom:0" @click="resetParam">RESET</button>
      </div>
      <div class="table-responsive table-scrollable space-loader" v-bind:class="{ loading: loading }">
        <vuetable
          ref="vuetable"
          :api-url="apiUrl"
          :append-params="appendParams"
          :http-options="httpOptions"
          :fields="fields"
          @vuetable:loading="onLoading"
          @vuetable:loaded="onLoaded"
          :css="css.table">
          <template slot="totalbet" slot-scope="props">
            <span>
              {{ props.rowData.total_bet_credit + props.rowData.total_bet_rolling | number}}
            </span>
          </template>
        </vuetable>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import Vuetable from 'vuetable-2/src/components/Vuetable'
  //  import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'

  export default {
    name: 'member-stakes-sum',
    components: {
      Vuetable
    },
    props: {
      reqTransactionId: '',
      // dateNow: '',
      userId: {
        type: Number
      }
    },
    computed: {
      apiUrl() {
        return `/api/members/${this.userId}/stakes/sum`
      }
    },
    data: function () {
      return {
        loading:false,
        css: {
          table: {
            tableClass: 'table table-striped table-bordered',
          }
        },
        fields: [
          {
            name: 'count',
            title: '#รายการทั้งหมด'
          },
          {
            name: '__slot:totalbet',
            title: 'เดิมพันทั้งหมด',
            titleClass: 'text-right',
            dataClass: 'text-right'
          },
        ],
        appendParams: {},
        moreParams: {
          userRequestId: '',
          range: {
            begin: '',
            ended: ''
          }
        },
        httpOptions: {
          headers: {
            'X-CSRF-TOKEN': window.App.csrfToken,
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + window.App.jwtToken
          }
        }
      }
    },
    mounted() {
      //
    },
    methods: {
      resetParam() {
        this.moreParams.userRequestId = ''
        this.appendParams = {}
        Vue.nextTick(() => this.$refs.vuetable.refresh())
      },
      transform(data) {
        var tranform = data
        return tranform
      },
      filterParam() {
        if (this.reqTransactionId) {
          // this.moreParams.userRequestId = this.reqTransactionId
        }
        this.appendParams = _.assign(this.appendParams, this.moreParams)
        Vue.nextTick(() => this.$refs.vuetable.refresh())
      },
      onLoading() {
        this.loading=true
      },
      onLoaded() {
        this.loading=false
      }
    },
    watch: {
      reqTransactionId: {
        handler: function (value, old) {
          const reqTransactionId = value
          if (this.reqTransactionId > 0) {
            this.moreParams.userRequestId = this.reqTransactionId
            this.filterParam()
          }
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// resources/assets/js/admin/components/MemberStakesSum/MemberStakesSum.vue